export const EntityChartFeatures = {
  CREntitySettings: 'CR-EntitySettings',
  CREntityAdd     : 'CR-Entity-Add',
  CREntityDelete  : 'CR-Entity-Delete',
  CREntityImport  : 'CR-Entity-Import'
};



